import { IShotgunSpot, IStateDispatchActions } from '../TeeSheetCreator.context';

export type IDisableShotgunSpot = (shotgunSpot: IShotgunSpot) => Promise<void>;

export const disableShotgunSpot: IStateDispatchActions<IDisableShotgunSpot> = (
  state,
  dispatch
) => async shotgunSpot => {
  const { shotgunSpots } = state;

  const newSpots = shotgunSpots.filter(
    spot =>
      !(
        spot.startingHole === shotgunSpot.startingHole &&
        spot.startingPosition === shotgunSpot.startingPosition
      )
  );

  dispatch({
    type: 'setShotgunSpots',
    value: newSpots
  });
};
